module.exports = __webpack_public_path__ + "static/media/ProfileDefault.27fbc5b3.svg";